import { createContext, ReactNode, useContext } from "react"
import { useToggle } from "react-use"

interface ContextValues {
    showAutoAdviceBlock: boolean
    showRefWidget: boolean
}

interface ContextHandlers {
    toggleShowAutoAdviceBlock: (value?: boolean) => void
    toggleShowRefWidget: (value: boolean) => void
}

const Context = createContext<[ContextValues, Partial<ContextHandlers>]>([
    {
        showAutoAdviceBlock: false,
        showRefWidget: false,
    },
    {},
])

interface Props {
    children: ReactNode
}

export function ClientAccountProvider({ children }: Props) {
    const [showAutoAdviceBlock, toggleShowAutoAdviceBlock] = useToggle(true)
    const [showRefWidget, toggleShowRefWidget] = useToggle(true)

    return (
        <Context.Provider
            value={[
                {
                    showAutoAdviceBlock,
                    showRefWidget,
                },
                {
                    toggleShowAutoAdviceBlock,
                    toggleShowRefWidget,
                },
            ]}
        >
            {children}
        </Context.Provider>
    )
}

export function useClientAccountContext() {
    return useContext(Context)
}
